import React from 'react';

export const useScroll = () => {
    const scrollToRef = (ref: HTMLElement | null, offset: number = 0) => {
        if (typeof window !== 'undefined' && ref !== null) {
            window.scrollTo(0, ref.offsetTop + offset);
        }
    };

    return scrollToRef;
};
